import React, {useContext} from 'react'
import { formularioContext } from '../contextos/FormularioContext'
import LinearProgress from '@mui/material/LinearProgress';
import Dialog from '@mui/material/Dialog';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';

export const Loader = ({open,
                          children,
                          texto})=>{
    const {datos,handleChangeCarrera} = useContext(formularioContext)
  
    return     <div>
    <Dialog fullScreen open={open} style={{opacity:'0.85'}}>
      <DialogContent style={{display:'flex',background:'steelblue',flexDirection:'column', justifyContent:'center',height:'100%',alignItems:'center'}}>
        <DialogContentText>
            <p style={{textAlign:'center'}}>{texto}</p>
        </DialogContentText>
        <LinearProgress/>
            {children}
      </DialogContent>
    </Dialog>
  </div>
}